<template lang="pug">
  #app
    Header
    router-view
    Footer
</template>


<script>
// @ is an alias to /src
import Header from '@/components/Global/Header.vue'
import Footer from '@/components/Global/Footer.vue'
export default {
  name: 'home',
  components: {
    Header, Footer
  }
}
</script>


<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
// Set your colors
//$primary: #ff6c37;
$primary: #1b46a8;
$primary-invert: findColorInvert($primary);
$primary-hover: rgb(183, 201, 221);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ( $white, $black),
  "black": ( $black, $white),
  "light": ( $light, $light-invert),
  "dark": ( $dark, $dark-invert),
  "primary": ( $primary, $primary-invert),
  "info": ( $info, $info-invert),
  "success": ( $success, $success-invert),
  "warning": ( $warning, $warning-invert),
  "danger": ( $danger, $danger-invert),
  "twitter": ( $twitter, $twitter-invert)
);
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

@font-face {
  font-family: "materialdesignicons";
  src: url("/fonts/materialdesignicons-webfont.woff2") format("woff2"),
    url("/fonts/materialdesignicons-webfont.woff") format("woff");
}
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";


.navbar {
  .navbar-brand {
    .navbar-item {
      padding: 5px!important;
      img {
        max-height: none!important;
      }
    }
  }
}

.losstimeConttentsContainer {
  section {
    .field {
      margin-bottom: 20px;
      .control {
        .input[type=text] {
          border-bottom-right-radius: 0!important;
          border-top-right-radius: 0!important;
        }
      }
    }
  }
}

.pagination-previous, .pagination-next {
  display: none!important;
}
header.datepicker-header {
  padding-bottom: 0px!important;
  .pagination.field.is-centered {
    margin-bottom: 0px!important;
    .pagination-list {
      .field.has-addons {
        .control {
          margin-left: 5px!important;
          margin-right: 5px!important;
        }
      }
    }
  }
}
</style>